import { render, staticRenderFns } from "./MovimentosAba.vue?vue&type=template&id=1a2b84e4&scoped=true"
import script from "./MovimentosAba.vue?vue&type=script&lang=js"
export * from "./MovimentosAba.vue?vue&type=script&lang=js"
import style0 from "./MovimentosAba.vue?vue&type=style&index=0&id=1a2b84e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b84e4",
  null
  
)

export default component.exports